module.exports = __webpack_public_path__ + "img/dy_2@2x.0fd9c949.png";